
import { defineComponent } from 'vue';

import InformationDocumentBlock from '../components/InformationDocumentBlock.vue';
import InformationFooter from '../components/InformationFooter.vue';
import InformationHeader from '../components/InformationHeader.vue';
import InformationInfoBlock from '../components/InformationInfoBlock.vue';
import InformationMainFunctionBlock from '../components/InformationMainFunctionBlock.vue';

export default defineComponent({
  name: 'InformationMainPage',
  components: {
    InformationHeader,
    InformationInfoBlock,
    InformationDocumentBlock,
    InformationFooter,
    InformationMainFunctionBlock,
  },
  setup() {
    return {};
  },
});
